import { mfaService } from "@services/mfaService";
import React, { useEffect } from "react";
import { useModalMfaChallenge } from "./ModalMfaChallenge";

export const MfaChallengeMount: React.FC = () => {
  const modal = useModalMfaChallenge();

  useEffect(
    () =>
      mfaService.registerHandler(async requirement => {
        const verified = await modal.open({ requirement });
        return !!verified;
      }),
    [modal]
  );

  return null;
};
